import { Map as ImmutableMap, Seq } from 'immutable';
function hashFunction(...args) {
  if (args.length === 1) {
    return args[0];
  }
  return Seq(args);
}
function memoizedN(cache, operation, expiration, ...args) {
  const key = hashFunction(...args);
  if (!cache.has(key)) {
    cache.set(key, operation(...args));
    if (expiration) {
      setTimeout(() => {
        cache.delete(key);
      }, expiration);
    }
  }
  return cache.get(key);
}
export default function memoizeWithTimeout(operation, expiration) {
  const cache = ImmutableMap().asMutable();
  const memoizer = memoizedN;
  const result = memoizer.bind(null, cache, operation, expiration);
  result.cache = cache;
  return result;
}